module.exports = __webpack_public_path__ + "static/media/27.a0f8a141.png";